export default __webpack_public_path__ + "images/symbols.svg?c93dbf4e8547363db109561d66c17d0e";